// Ключ настройки поля и правила подсчёта совпадают с lk_backend/lk_app/task_data_validation.py:
// сервер повторяет эту проверку при сохранении и отправке задания.
export const ANALYTE_NUMBER_KEY = 'analyte_number';

// null, undefined и пустая строка (в том числе из пробелов) — не заполнено, 0 — заполнено.
export function isFilledValue(value) {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim() !== '';
  }
  return true;
}

function getAnalyteNumber(fieldSchema) {
  if (!fieldSchema || typeof fieldSchema !== 'object') {
    return null;
  }
  const raw = fieldSchema[ANALYTE_NUMBER_KEY];
  if (raw === undefined || raw === null || raw === '' || typeof raw === 'boolean') {
    return null;
  }
  const number = Number(raw);
  return Number.isInteger(number) && number > 0 ? number : null;
}

// Номера аналитов, у которых заполнено хотя бы одно поле, по возрастанию.
export function getSelectedAnalytes(schema, data) {
  const properties = schema?.properties;
  if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
    return [];
  }
  if (!data || typeof data !== 'object') {
    return [];
  }

  const selected = new Set();
  for (const [fieldName, fieldSchema] of Object.entries(properties)) {
    const number = getAnalyteNumber(fieldSchema);
    if (number !== null && isFilledValue(data[fieldName])) {
      selected.add(number);
    }
  }
  return [...selected].sort((a, b) => a - b);
}

export function analyteLimitErrorMessage(limit) {
  return `Вы превысили заказанное количество аналитов. Заказанное количество не более ${limit}`;
}
